import { render, staticRenderFns } from "./TechnicalTreasureMessages.vue?vue&type=template&id=208c38b6&scoped=true&"
import script from "./TechnicalTreasureMessages.vue?vue&type=script&lang=js&"
export * from "./TechnicalTreasureMessages.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalTreasureMessages.vue?vue&type=style&index=0&id=208c38b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c38b6",
  null
  
)

export default component.exports